import unicreditLogoFooter from '@/images/clients/unicredit-broker-logo.png'
import type { IPartnerSettings } from '.'

export const Jap: IPartnerSettings = {
  partner: 'Jap',
  deployment: 'Jap',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.Jap',
    test: 'https://pojisteni.unicreditleasing.cz/test',
    prep: '',
    production: 'https://pojisteni.unicreditleasing.cz/produkce',
  },
  hosts: [
    'pojisteni.unicreditleasing.cz'
    // , 'localhost:44470'
  ],
  logo: unicreditLogoFooter
}
